import { AxiosPromise, AxiosResponse } from 'axios';

import { request } from '@cvt/clients/baseClient';
import { snakizeObject } from '@cvt/helpers/object';

import { mapDisciplineData } from './disciplineClient.formatter';


const apiBaseUrl = import.meta.env.VITE__CVT_API_URL;

const getDisciplines = (params: Disciplines.GetListParams): AxiosPromise<CVT.Query.PaginatedResults<Disciplines.Discipline>> => {
  return request({
    options: {
      url: `${apiBaseUrl}/disciplines/`,
      method: 'GET',
      params: snakizeObject(params),
    },
  }).then((data: AxiosResponse<CVT.Query.PaginatedResults<Disciplines.DisciplineApi>>) => ({
    ...data,
    data: {
      ...data.data,
      results: data.data.results.map(mapDisciplineData),
    },
  }));
};

const getDiscipline = (params: { id: number }): AxiosPromise<Disciplines.Discipline> => {
  return request({
    options: {
      url: `${apiBaseUrl}/disciplines/${params.id}/`,
      method: 'GET',
    },
  }).then((data: AxiosResponse<Disciplines.DisciplineApi>) => ({
    ...data,
    data: mapDisciplineData(data.data),
  }));
};

const likeDiscipline = (params: { id: number }): AxiosPromise<Disciplines.Discipline> => {
  return request({
    options: {
      url: `${apiBaseUrl}/disciplines/${params.id}/favourite/`,
      method: 'POST',
    },
  }).then((data: AxiosResponse<Disciplines.DisciplineApi>) => ({
    ...data,
    data: mapDisciplineData(data.data),
  }));
};

const unlikeDiscipline = (params: { id: number }): AxiosPromise<Disciplines.Discipline> => {
  return request({
    options: {
      url: `${apiBaseUrl}/disciplines/${params.id}/unfavourite/`,
      method: 'POST',
    },
  }).then((data: AxiosResponse<Disciplines.DisciplineApi>) => ({
    ...data,
    data: mapDisciplineData(data.data),
  }));
};

const ignoreDiscipline = (params: { id: number }): AxiosPromise<Disciplines.Discipline> => {
  return request({
    options: {
      url: `${apiBaseUrl}/disciplines/${params.id}/ignore/`,
      method: 'POST',
    },
  }).then((data: AxiosResponse<Disciplines.DisciplineApi>) => ({
    ...data,
    data: mapDisciplineData(data.data),
  }));
};

export const disciplineClient = {
  getDisciplines,
  getDiscipline,
  likeDiscipline,
  unlikeDiscipline,
  ignoreDiscipline,
};
